<template>
    <mt-popup
            style="width: 100%;height: 100%;"
            v-model="destinationPopup"
            position="right">
        <div style="background: #fff;">
            <div>
                <div style="height: 52px;overflow: hidden;">
                    <mt-search cancel-text="" placeholder="输入目的地国家编码/名称/仓库代码" v-model="search.destination"
                               @input.native="inputEvent" @keyup.enter.native="searchData()"></mt-search>
                </div>
                <div style="background: #f5f5f5;">
                    <mt-index-list :height="indexListHeight">
                        <div v-if="infoShow&&result.destCountries&&result.destCountries.length!==0">
                            <p class="mint-indexsection-index">
                                常用/最近历史
                            </p>
                            <div style="padding:0 10px;" class="country-list">
                                <span :class="{'cur': choosedItem.name == item.destination&&choosedItem.code==item.purposeCode}"
                                      @click="choose(item)" v-for="(item,index) in result.destCountries" :key="index">{{item.destination}}<b>/{{item.purposeCode}}</b></span>
                            </div>
                        </div>
                        <div v-if="infoShow&&result.countries&&result.countries.length!==0">
                            <p class="mint-indexsection-index">
                                热门国家
                            </p>
                            <div style="padding:0 10px;" class="country-list">
                                <span :class="{'cur': choosedItem.name == item.destination&&choosedItem.code==item.purposeCode}"
                                      @click="choose(item)" v-for="(item,index) in result.countries" :key="index">{{item.destination}}<b>/{{item.purposeCode}}</b></span>
                            </div>
                        </div>

                        <mt-index-section :index="item.str" v-for="(item,index) in result.results" :key="index"
                                          v-if="item.list.length>0">
                            <p class="country-list country-block-list" v-for="(subItem, subIndex) in item.list"
                               :key="subIndex">
                                <span :class="{'cur': choosedItem.name == subItem.destination&&choosedItem.code==subItem.purposeCode}"
                                      @click="choose(subItem)" slot="title">{{subItem.destination}}<b>/{{subItem.purposeCode}}</b></span>
                            </p>
                        </mt-index-section>
                    </mt-index-list>
                </div>
            </div>
        </div>
    </mt-popup>
</template>
<script>

    export default {
        computed: {
            indexListHeight() {
                return window.screen.height - 156;
            }
        },
        data() {
            return {
                destinationPopup: false,
                search: {
                    companyNo: '',
                    destination: ''
                },
                result: {},
                infoShow: true,
                choosedItem: {
                    code: '',
                    name: '',
                    id: '',
                    destType:null
                }
            }
        },
        created() {
            this.search.companyNo = this.$util.get('companyNo')
        },
        methods: {
            inputEvent(e) {
                this.search.destination = e.target.value;
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                setTimeout(() => {
                    this.searchData();
                },1000)

            },
            open() {
                this.destinationPopup = true;
                this.searchData();
            },
            close() {
              this.destinationPopup = false;
            },
            searchData() {
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                if (this.search.destination) {
                    this.infoShow = false;
                } else {
                    this.infoShow = true;
                }
                this.http.send({command: 'destCountry/destCountries', params: this.search}).then(res => {
                    this.result = res.data.body;
                    this.$indicator.close();
                })
            },
            choose(obj) {
                this.$set(this.choosedItem, 'code', obj.purposeCode);
                this.$set(this.choosedItem, 'name', obj.destination);
                this.$set(this.choosedItem, 'destType', obj.destType);
                this.$set(this.choosedItem, 'id', obj.id);
                this.$emit('getCountryCode', this.choosedItem);
                this.destinationPopup = false;
            }
        }
    }
</script>
<style lang="less">
    .country-list span {
        display: inline-block;
        background: #fff;
        color: #333;
        font-size: 15px;
        padding: 6px 10px;
        border-radius: 4px;
        margin-bottom: 8px;
        margin-right: 8px;
        b {
            font-weight: normal;
            font-size: 12px;
            color: #999999;
        }
        &.cur {
            color: #26a2ff;
            b {
                color: #26a2ff;
            }
        }

    }

    .country-block-list {
        border-bottom: 1px solid #f5f5f5;
    }

    .country-block-list span {
        display: block;
        border-radius: 0;
        margin-bottom: 0;
        margin-right: 0;

        &.cur {
            color: #26a2ff;

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/omsDestination/index.vue